

























































import Enumerable from "linq";
import { Component, Mixins } from "vue-property-decorator";
import { Department } from "../../../domain/department";
import { ISingleSelectableAsynchronously, ISingleSelectableConditionallyAsynchronously } from "../../system/selectors";
import DepartmentListSelector from "../selectors/DepartmentListSelector.vue";
import { IDepartmentListSelectorDialogCondition, instanceOfIDepartmentListSelectorDialogCondition } from "./IDepartmentListSelectorDialogCondition";
import { DepartmentSelectableDialogMixin } from "./mixins";

@Component({
  components: {
    DepartmentListSelector,
  },
})
export default class DepartmentListSelectorDialog extends Mixins(DepartmentSelectableDialogMixin) implements ISingleSelectableAsynchronously<Department>, ISingleSelectableConditionallyAsynchronously<Department, IDepartmentListSelectorDialogCondition> {
  async selectOption(defaultOption?: Department): Promise<Department> {
    return this.show<Department>(defaultOption);
  }

  async selectOptionConditionally(condition?: IDepartmentListSelectorDialogCondition, defaultOptions?: Department): Promise<Department> {
    if (instanceOfIDepartmentListSelectorDialogCondition(condition)) {
      this.name = condition.name ? condition.name : "";
      this.nonDisplayDepartmentCodes = condition.nonDisplayDepartmentCodes ? condition.nonDisplayDepartmentCodes : null;
      this.departmentGroup = condition.departmentGroup;
    }
    return this.show<Department>(defaultOptions);
  }

  selectLoginDepartment(): void {
    if (Enumerable.from(this.nonDisplayDepartmentCodes).contains(this.$store.getters.department.id)) {
      this.$warn(
        "診療科選択",
        "ログイン診療科を選択できません。");
      return;
    }
    this.select(this.$store.getters.department);
  }
}
